export const PROOF_APPROVAL_MODES = Object.freeze({
  COMPLETE_PACKAGE: "complete_package",
  PER_LOCATION: "per_location",
});

export const normalizeProofApprovalMode = (value) =>
  String(value || "").trim().toLowerCase() === PROOF_APPROVAL_MODES.PER_LOCATION
    ? PROOF_APPROVAL_MODES.PER_LOCATION
    : PROOF_APPROVAL_MODES.COMPLETE_PACKAGE;
